import { HStack, Text } from '@chakra-ui/react';
import { FC } from 'react';

import useSession from '@/hooks/useSession';
import { IConversationMessage } from '@/utils/conversation/types';

import { NestedChatMessageMenu } from './NestedChatMessageMenu';
import { NestedChatMessageTimestamp } from './NestedChatMessageTimestamp';

interface INestedChatMessageHeaderProps {
  message: IConversationMessage;
}

export const NestedChatMessageHeader: FC<INestedChatMessageHeaderProps> = ({ message }) => {
  const { user } = useSession();
  const isUserAllowedToDelete = user?.role === 'admin' || message.author === user?.email;

  return (
    <HStack justifyContent="space-between" alignItems="flex-start" w="full" spacing={0}>
      <HStack alignItems="center" flexWrap="wrap" spacing={0}>
        <Text fontSize="sm" fontWeight="bold" mr={2} wordBreak="break-word">
          {`${message.attributes.nameToDisplay || message.author}`}
        </Text>
        <NestedChatMessageTimestamp timestamp={message.dateCreated} />
      </HStack>
      {isUserAllowedToDelete ? <NestedChatMessageMenu message={message} /> : null}
    </HStack>
  );
};
